export default "__VITE_ASSET__7c6d6860__"